import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import apiClient from "../services/apiClient";
import { authService } from "../services/authService";

// 운영진 보기(2026-09-30). fuddl3297 계정이 학원을 고르면 그 학원 계정 토큰으로 화면을 다시 연다.
// 모든 메뉴가 그 학원 것으로 뜬다. 서버가 보기 전용으로 막는다(api/user/admin_view.py).
// 원래 운영진 토큰은 아래 두 칸에 쥐고 있다가 '돌아가기' 에서 되돌린다.
// 학원 목록은 오른쪽 위 계정 메뉴(UserMenu), 보는 중 표시는 맨 위 줄(AdminViewPicker)이 그린다.

// 학원 화면을 볼 수 있는 계정. 서버 api/user/admin_view.py 의 같은 이름 상수와 맞춘다.
export const ADMIN_VIEW_NICKNAME_LIST = ["fuddl3297"];
const ORIGIN_ACCESS_KEY = "admin_origin_access_token";
const ORIGIN_REFRESH_KEY = "admin_origin_refresh_token";

export const academyNameOf = (one) => one.organization_name || one.name || one.nickname || "";

export const useAdminView = ({ loadList = false } = {}) => {
  const { user } = useSelector((state) => state.auth);
  const isViewing = Boolean(user.admin_viewer_name);
  const canView = isViewing || ADMIN_VIEW_NICKNAME_LIST.includes(user.nickname);
  const [academyList, setAcademyList] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!canView || !loadList || academyList.length) return;
    apiClient
      .get("/api/v1/user/all?view_list=1", { withAuth: true })
      .then((response) => setAcademyList(response.data || []))
      .catch(() => setMessage("학원 목록을 불러오지 못했어요."));
  }, [canView, loadList, academyList.length]);

  const viewAs = useCallback(
    async (userId) => {
      setMessage("");
      try {
        const response = await apiClient.post("/api/v1/admin/view-as", { user_id: userId }, { withAuth: true });
        if (!isViewing) {
          localStorage.setItem(ORIGIN_ACCESS_KEY, authService.getAccessToken() || "");
          localStorage.setItem(ORIGIN_REFRESH_KEY, authService.getRefreshToken() || "");
        }
        authService.setTokens(response.data.access_token, response.data.refresh_token);
        window.location.assign("/");
      } catch (caught) {
        setMessage(caught.response?.data?.error || "학원 화면을 열지 못했어요.");
      }
    },
    [isViewing]
  );

  const goBack = useCallback(() => {
    const access = localStorage.getItem(ORIGIN_ACCESS_KEY);
    const refresh = localStorage.getItem(ORIGIN_REFRESH_KEY);
    if (access && refresh) {
      localStorage.removeItem(ORIGIN_ACCESS_KEY);
      localStorage.removeItem(ORIGIN_REFRESH_KEY);
      authService.setTokens(access, refresh);
    } else {
      authService.removeTokens();
    }
    window.location.assign("/");
  }, []);

  return { user, isViewing, canView, academyList, message, viewAs, goBack };
};
